// extracted by mini-css-extract-plugin
export default {"wraper":"Mariusz_wraper__n67Eh","photo":"Mariusz_photo__19nYd","title":"Mariusz_title__2xgfC","sub":"Mariusz_sub__8N5Et","name":"Mariusz_name__+p41H","text":"Mariusz_text__gkcQ6"};